<router-outlet>
</router-outlet>
<!-- <div class="container-fluid w-100 h-100 ios-instructions" [class.reveal-instructions]="revealIOSInstructions">
  <div class="gradient"></div>
  <div class="row pt-3">
    <div class="col-auto ml-auto mr-4">
      <button (click)="closeIOS();">&#x2715;</button>
    </div>
  </div>
  <div class="row justify-content-center pt-2 pb-3">
    <div class="col-11 px-2">
      <div class="row">
        <div class="col-5">
          <img src="../../../assets/ios-help.png">
        </div>
        <div class="col-7 my-auto">
          <h1>Troubleshooting Sonoma Plaza History Tour</h1>
        </div>
      </div>
      <h2 class="mt-4">Location Services<br><i>IOS (Apple Devices)</i></h2>
      <p class="mt-4"><b>How to turn Location Services on or off for specific apps</b></p>
      <ol>
        <li class="mt-4">Go to <b>Settings > Privacy > Location Services.</b></li>
        <li class="mt-4">Make sure that Location Services is set to on.</li>
        <li class="mt-4">Scroll down to <b>your preferred web browser app</b>. I.E. <i>Safari</i></li>
        <li class="mt-4">
          Tap the app and select an option listed below:
          <ul>
            <li>
              <b>Ask Next Time:</b> This allows you to choose Always While Using App, Allow Once, or Don't Allow.
            </li>
            <li>
              <b>While Using the App: </b> Allows access to Location Services only when the app or one of its features is visible on screen. If an app is set to Whil Using the App, you might see your status bar turn blue with a message that an app is actively using your location.
            </li>
            <li>
              <b>Always:</b> Allows access to your location even when the app is in the background.
            </li>
          </ul>
        </li>
      </ol>
    </div>
  </div>
</div> -->
